import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SurveyRoutingModule } from './survey-routing.module';
import { SurveyListComponent } from './survey-list/survey-list.component';
import { QuotaComponent } from './quota/quota.component';
import { DetailsComponent } from './details/details.component';
import { CallbackurlComponent } from './callbackurl/callbackurl.component';
import { SurveyFilterComponent } from './survey-list/survey-filter/survey-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { TargetGroupComponent } from './target-group/target-group.component';
import { CompletionReportComponent } from './completion-report/completion-report.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { UploadRejectionsComponent } from './upload-rejections/upload-rejections.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SendMailModalComponent } from './survey-list/send-mail-modal/send-mail-modal.component';
import { SendCommComponent } from './survey-list/send-comm/send-comm.component';



@NgModule({
  declarations: [
    SurveyListComponent,
    QuotaComponent,
    DetailsComponent,
    CallbackurlComponent,
    SurveyFilterComponent,
    TargetGroupComponent,
    CompletionReportComponent,
    UploadRejectionsComponent,
    SendMailModalComponent,
    SendCommComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    InfiniteScrollModule,
    SurveyRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgbDropdownModule
  ]
})
export class SurveyModule { }
